<script setup lang="ts">
const props = defineProps<{
  parent: HTMLElement | null
  label: string
  href: string
}>()

const progress = ref(0)

const router = useRouter()
const { $ScrollTrigger } = useNuxtApp()

const { isTransitioning, loadedTransition } = useGlobalState()

const $infiniteLink = useTemplateRef('$infiniteLink')

let trigger: ScrollTrigger | null = null

watch([isTransitioning, $infiniteLink], async () => {
  if (isTransitioning.value || !$infiniteLink.value) {
    return
  }

  setTimeout(() => {
    trigger = $ScrollTrigger.create({
      trigger: $infiniteLink.value,
      start: 'top bottom-=56px',
      end: 'bottom top-=100vh',
      pin: props.parent,
      anticipatePin: 1,

      onUpdate: (self) => {
        progress.value = self.progress

        if (progress.value >= 0.99 && trigger?.isActive) {
          trigger?.kill()

          setTimeout(() => {
            progress.value = 1
            loadedTransition.value = 'infinite'
            router.push(props.href)
          })
        }
      },
    })
  }, 1000)
})

onUnmounted(() => {
  trigger?.kill()
})
</script>

<template>
  <div
    ref="$infiniteLink"
    class="flex h-[56px] items-center justify-center overflow-hidden bg-black after:pointer-events-none after:fixed after:inset-0 after:z-100 after:mb-[56px] after:bg-black/90 after:opacity-(--progress)"
    :style="{ '--progress': progress }"
  >
    <div class="relative z-1 h-[56px] w-[calc(100%+2rem)] -skew-x-[20deg]">
      <div class="bg-neon-yellow/70 absolute -inset-x-10 inset-y-0" />

      <div
        class="bg-neon-yellow absolute inset-0 -inset-x-4 origin-left scale-x-(--progress)"
        :style="{ '--progress': progress }"
      />
    </div>

    <h2 class="px-bleed absolute z-2 flex w-full justify-between font-mono text-sm uppercase">
      <span>{{ label }}</span>
      <span>[{{ (progress * 100).toFixed(0) }}%]</span>
    </h2>
  </div>
</template>
